<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a><i>Shanghai Nightscapes</i></h1>
<h1 class="bk1">A Nocturnal Biography of a Global City</h1>
<p class="bkau">JAMES FARRER AND ANDREW DAVID FIELD</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-farrer-0003.vue?0a0130ca